var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Select from 'react-select';
import classNames from 'classnames';
import { ApplicationContext } from '../../../../ApplicationContext';
import GetAvailableMeasurementsCommand from "../../../../commands/metrics/GetAvailableMeasurementsCommand";
import MeasurementCollection from "../../../../collections/metrics/MeasurementCollection";
import { Col, Nav, NavItem, NavLink, Row } from "reactstrap";
import DateRange from "../../../components/ui/DateRange/DateRange";
import SampleCollection from "../../../../collections/metrics/SampleCollection";
import SampleMetaDataCollection from "../../../../collections/metrics/SampleMetaDataCollection";
import DateRangePreset, { getDateRangeFromPreset } from "../../../../data/DateRangePreset";
import { MetricsIntervalType } from "../../../../data/MetricsIntervalType";
import GetSamplesCommand from "../../../../commands/metrics/GetSamplesCommand";
import { getEnumKeys } from "../../../../utils/enumUtils";
import { ChartColors } from "../../../../data/ChartColors";
import MetricsGraphs from "../../Metrics/MetricsGraphs";
import MetricsTables from "../../Metrics/MetricsTables";
import { EmptyDiv } from "../../../components/ui/EmptyDiv/EmptyDiv";
import AssetLocationMetricsTable from "./AssetLocationMetricsTable";
import { HideBatteryVoltageSample } from "../../../../utils/HideBatteryVoltageSampleHelper";
var VIEW_STATE_CHART = 'view_state_chart';
var VIEW_STATE_TABLE = 'view_state_table';
var VIEW_STATE_LOCATION = 'view_state_location';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var AssetMetrics = /** @class */ (function (_super) {
    __extends(AssetMetrics, _super);
    /**
     *
     * @param props
     */
    function AssetMetrics(props) {
        var _this = _super.call(this, props) || this;
        _this.onDateRangeSelected = _this.onDateRangeSelected.bind(_this);
        _this.onDateRangeChanged = _this.onDateRangeChanged.bind(_this);
        _this.retrieveSamples = _this.retrieveSamples.bind(_this);
        _this.dateRangePresetOptions = Object.keys(DateRangePreset).map(function (key) {
            return {
                value: key,
                label: props.intl.formatMessage({ id: DateRangePreset[key].labelId }),
                preset: DateRangePreset[key]
            };
        });
        _this.dateRangePresetOptions.push({
            value: 'custom',
            label: props.intl.formatMessage({ id: 'daterange.preset.days.custom' }),
            preset: null
        });
        _this.state = {
            measurementCollection: new MeasurementCollection(),
            sampleCollection: new SampleCollection(),
            sampleMetaDataCollection: new SampleMetaDataCollection(),
            selectedDateRangePreset: DateRangePreset.MONTH_CURRENT,
            selectedDateRange: getDateRangeFromPreset(DateRangePreset.MONTH_CURRENT),
            chartsData: [],
            interval: MetricsIntervalType.DAY,
            activeTab: 0,
            activeTabName: null,
            viewState: VIEW_STATE_CHART,
            initialized: false
        };
        return _this;
    }
    /**
     *
     */
    AssetMetrics.prototype.componentDidMount = function () {
        this.componentInitialize();
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    AssetMetrics.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (prevProps.assetModel !== this.props.assetModel) {
            this.componentInitialize();
        }
    };
    /**
     *
     */
    AssetMetrics.prototype.componentInitialize = function () {
        var _this = this;
        var command = new GetAvailableMeasurementsCommand();
        this.setState({ loading: true });
        command.execute(this.context.session.user.organisation, [this.props.assetModel], this.state.measurementCollection).then(function () {
            _this.retrieveSamples();
        });
    };
    /**
     *
     * @return {*}
     */
    AssetMetrics.prototype.render = function () {
        var _this = this;
        var session = this.context.session;
        var assetModel = this.props.assetModel;
        var _a = this.state, chartsData = _a.chartsData, selectedDateRangePreset = _a.selectedDateRangePreset, selectedDateRange = _a.selectedDateRange, interval = _a.interval, initialized = _a.initialized, activeTab = _a.activeTab, viewState = _a.viewState, activeTabName = _a.activeTabName, loading = _a.loading;
        if (!session.isLoggedIn) {
            return null;
        }
        var dateRange = getDateRangeFromPreset(selectedDateRangePreset);
        if (!dateRange) {
            dateRange = selectedDateRange;
        }
        var timeRange = {
            fromUnixTimeMillis: selectedDateRange[0].getTime(),
            toUnixTimeMillis: selectedDateRange[1].getTime()
        };
        return React.createElement("div", { className: "asset-history w-100" },
            React.createElement(Row, { className: "mt-3" },
                React.createElement(Col, { sm: "6", className: "flex-column flex-grow-1" },
                    React.createElement("label", { className: "font-weight-bold" },
                        React.createElement(FormattedMessage, { id: "daterange.label.preset" })),
                    React.createElement(Select, { className: "form-control select2 mb-3", classNamePrefix: "select2", options: this.dateRangePresetOptions, defaultValue: this.dateRangePresetOptions[2], onChange: this.onDateRangeSelected })),
                React.createElement(Col, { sm: "6", className: "" }, !selectedDateRangePreset ?
                    React.createElement(DateRange, { onChange: this.onDateRangeChanged, startDate: dateRange[0], endDate: dateRange[1] }) : null)),
            this.hasSamples() ?
                React.createElement(Row, null,
                    React.createElement(Col, { sm: 12 },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                            viewState !== VIEW_STATE_LOCATION ?
                                React.createElement(Nav, { tabs: true, className: "mb-3" }, chartsData.map(function (datasets, index) {
                                    return React.createElement(NavItem, { key: index },
                                        React.createElement(NavLink, { className: classNames({ active: _this.state.activeTab === index }), onClick: function () {
                                                _this.setState({
                                                    activeTab: index,
                                                    activeTabName: datasets[0].name
                                                });
                                            } }, datasets[0].name));
                                })) :
                                React.createElement("div", { className: "d-flex align-items-center mb-3", style: { height: '54px', width: '100%' } },
                                    React.createElement("h4", { className: "mb-0" },
                                        React.createElement(FormattedMessage, { id: "metrics.locations" }))),
                            React.createElement("div", { className: "nav btn-group d-inline-flex flex-nowrap ml-4" },
                                React.createElement("button", { className: 'btn btn-white' + (viewState === VIEW_STATE_TABLE ? ' active' : ''), onClick: function () {
                                        _this.setState({ viewState: VIEW_STATE_TABLE });
                                    } },
                                    React.createElement("span", { className: "fe fe-list" })),
                                React.createElement("button", { className: 'btn btn-white ' + (viewState === VIEW_STATE_CHART ? ' active' : ''), onClick: function () {
                                        _this.setState({ viewState: VIEW_STATE_CHART });
                                    } },
                                    React.createElement("span", { className: "fe fe-bar-chart-2" })),
                                React.createElement("button", { className: 'btn btn-white ' + (viewState === VIEW_STATE_LOCATION ? ' active' : ''), onClick: function () {
                                        _this.setState({ viewState: VIEW_STATE_LOCATION });
                                    } },
                                    React.createElement("span", { className: "fe fe-map-pin" }))))),
                    React.createElement(Col, { sm: 12 },
                        viewState === VIEW_STATE_CHART && chartsData.length > 0 ?
                            React.createElement(MetricsGraphs, { chartsData: chartsData, unit: interval.toLowerCase(), activeTab: activeTab, name: activeTabName }) : null,
                        viewState === VIEW_STATE_TABLE && chartsData.length > 0 ?
                            React.createElement(MetricsTables, { chartsData: chartsData, activeTab: activeTab, assetModel: assetModel }) : null,
                        viewState === VIEW_STATE_LOCATION ?
                            React.createElement(AssetLocationMetricsTable, { interval: interval, timeRange: timeRange, assetModel: assetModel }) : null,
                        chartsData.length === 0 ? React.createElement(EmptyDiv, null) : null)) : null,
            (!loading && initialized && !this.hasSamples()) ?
                React.createElement(Row, null,
                    React.createElement(EmptyDiv, null)) : null);
    };
    /**
     *
     */
    AssetMetrics.prototype.retrieveSamples = function () {
        var _this = this;
        var assetModel = this.props.assetModel;
        var session = this.context.session;
        var _a = this.state, selectedDateRange = _a.selectedDateRange, measurementCollection = _a.measurementCollection, sampleMetaDataCollection = _a.sampleMetaDataCollection, sampleCollection = _a.sampleCollection, interval = _a.interval;
        var command = new GetSamplesCommand();
        var unit = interval.toLocaleLowerCase();
        var amount = 1;
        var intervalString = amount + ' ' + unit + (amount > 1 ? 's' : '');
        var selectedMeasurements = measurementCollection.list.concat([]);
        command.execute(session.user.organisation, sampleCollection, sampleMetaDataCollection, [assetModel.getMetricsDbId()], selectedMeasurements.map(function (measurement) { return measurement.id; }), intervalString, { fromUnixTimeMillis: selectedDateRange[0].getTime(), toUnixTimeMillis: selectedDateRange[1].getTime() })
            .then(function () {
            var chartsData = _this.generateDatasets();
            _this.setState({
                chartsData: chartsData,
                activeTab: 0,
                loading: false,
                initialized: true,
                activeTabName: chartsData[0][0].name
            });
        }).catch(function (error) {
            _this.setState({ chartsData: [], loading: false, initialized: true });
        });
    };
    AssetMetrics.prototype.generateDatasets = function () {
        var _a = this.props, assetModel = _a.assetModel, intl = _a.intl;
        var _b = this.state, measurementCollection = _b.measurementCollection, sampleCollection = _b.sampleCollection;
        var chartsData = [];
        //
        if (sampleCollection.list.length > 0) {
            var measurementIds_1 = [];
            var measurementModels_1 = [];
            measurementCollection.list.forEach(function (measurementModel) {
                if (HideBatteryVoltageSample(assetModel, measurementModel)) { // Battery voltage
                    // Do nothing
                }
                else if (measurementIds_1.indexOf(measurementModel.id) < 0) {
                    measurementIds_1.push(measurementModel.id);
                    measurementModels_1.push(measurementModel);
                }
            });
            var colors_1 = getEnumKeys(ChartColors).map(function (key) { return ChartColors[key]; });
            var colorIndex_1 = 0;
            // Create dataset per measurement type
            measurementIds_1.forEach(function (measurementId, measurementIndex) {
                var datasets = [];
                //
                var assetMetricsId = assetModel.getMetricsDbId();
                var samples = sampleCollection.getSamplesForAssetAndMeasurement(assetMetricsId, measurementId);
                // Only add when samples are found
                if (samples.length > 0) {
                    datasets.push({
                        unit: measurementModels_1[measurementIndex].unit,
                        name: intl.formatMessage({
                            id: 'measurement.' + measurementModels_1[measurementIndex].name,
                            default: measurementModels_1[measurementIndex].name
                        }),
                        label: assetModel.id,
                        data: samples.map(function (sampleModel) {
                            return { x: sampleModel.timestamp, y: sampleModel.getNormalizedSampleValue() };
                        }),
                        fill: false,
                        backgroundColor: colors_1[colorIndex_1 % colors_1.length],
                        borderColor: colors_1[colorIndex_1 % colors_1.length]
                    });
                    colorIndex_1++;
                }
                if (datasets.length > 0) {
                    chartsData.push(datasets);
                }
            });
        }
        return chartsData;
    };
    /**
     *
     */
    AssetMetrics.prototype.onDateRangeChanged = function (dates) {
        var _this = this;
        this.setState({ selectedDateRange: dates, selectedDateRangePreset: null }, function () { return _this.retrieveSamples(); });
    };
    /**
     *
     */
    AssetMetrics.prototype.onDateRangeSelected = function (data) {
        var _this = this;
        var dateRange = getDateRangeFromPreset(data.preset);
        this.setState({ selectedDateRangePreset: data.preset });
        if (dateRange) {
            this.setState({
                selectedDateRangePreset: data.preset,
                selectedDateRange: dateRange
            }, function () { return _this.retrieveSamples(); });
        }
        else {
            this.setState({ selectedDateRangePreset: data.preset }, function () { return _this.retrieveSamples(); });
        }
    };
    /**
     *
     */
    AssetMetrics.prototype.canRetrieveSamples = function () {
        var selectedDateRange = this.state.selectedDateRange;
        return !!selectedDateRange;
    };
    /**
     *
     */
    AssetMetrics.prototype.hasSamples = function () {
        return this.state.sampleCollection.list.length > 0;
    };
    AssetMetrics.defaultProps = {
        className: '',
    };
    AssetMetrics = __decorate([
        observer
    ], AssetMetrics);
    return AssetMetrics;
}(React.Component));
AssetMetrics.contextType = ApplicationContext;
export default injectIntl(AssetMetrics);
